import { Box, Typography } from "@mui/material";
import { forwardRef, memo } from "react";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

const EmptyUserState = forwardRef((props, ref) => {
  const { isATeacher, isAStudent } = useAppContext();
  /**
   * =========================================================
   * ✅ Dynamic messaging based on role
   * =========================================================
   */
  let headline = "Noch nichts geplant 📭";
  let mainText = " Hier ist aktuell noch nichts verfügbar.";
  let subText = "Bitte schaue später noch einmal vorbei.";

  if (isATeacher) {
    subText =
      "Falls du eine Idee für einen Event hast, melde dich beim IT-Support.";
  }

  if (isAStudent) {
    subText =
      "Sobald die Planung freigeschaltet ist, kannst du dich hier anmelden.";
  }

  return (
    <Box
      sx={{
        mt: 8,
        px: 2,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      {/* ✅ HEADLINE */}
      <Typography variant="h5">{headline}</Typography>

      {/* ✅ MAIN MESSAGE */}
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          maxWidth: 420,
        }}
      >
        {mainText}
      </Typography>

      {/* ✅ ROLE-SPECIFIC SUBTEXT */}
      <Typography
        variant="body2"
        sx={{
          mt: 1,
          color: "text.secondary",
          opacity: 0.8,
          maxWidth: 400,
        }}
      >
        {subText}
      </Typography>
    </Box>
  );
});

export default memo(EmptyUserState);
